import { Link } from "react-router-dom";
import { latestMovies, trendingMovies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function LatestMovies() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新上映
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新最新电影资源</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              {...movie}
              showBadge
              badgeText="新上"
            />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网热播电影推荐</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {trendingMovies.map((movie, index) => (
            <MovieCard
              key={movie.id}
              {...movie}
              showBadge
              badgeText={`TOP ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}